<template>
  <div>
    <v-card elevation="0">
      <v-card-title>Cookies are disabled</v-card-title>
      <v-card-text
        >Please enable browser cookies or you can launch this poll in a separate
        browser tab to continue.</v-card-text
      >
      <v-card-actions
        ><v-btn href="/embed" target="_blank"
          >Launch Poll</v-btn
        ></v-card-actions
      >
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
